export const translations = {
  en: {
    messages: 'Messages',
    searchPeople: 'Search people...',
    recentChats: 'Recent Chats',
    allEmployees: 'All Employees',
    noResults: 'No results found',
    tryDifferent: 'Try searching with a different keyword',
    noEmployees: 'No employees available',
    selectPerson: 'Select a person to start messaging',
    yourMessages: 'Your Messages',
    activeNow: 'Active now',
    offline: 'Offline',
    typing: 'typing...',
    sending: 'Sending...',
    sent: 'Sent',
    delivered: 'Delivered',
    read: 'Read',
    seen: 'Seen',
    justNow: 'Just now',
    startConversation: 'Start a conversation',
    loading: 'Loading messages...',
    errorTitle: 'Error',
    retry: 'Retry',
    typeMessage: 'Type a message...',
    cannotMessageSelf: 'Cannot send messages to yourself',
    userInfoMissing: 'User information missing',
    sendFailed: 'Failed to send message. Please try again.',
    uploading: 'Uploading...',
    file: 'File',
    download: 'Download',
    recording: 'Recording...',
    voiceMessage: 'Voice Message',
    stop: 'Stop',
    send: 'Send',
    cancel: 'Cancel',
    microphoneAccess: 'Please allow microphone access',
    sharedMedia: 'Shared Media',
    aboutChat: 'About this chat',
    contactInfo: 'Contact Info',
    noSharedMedia: 'No shared media yet.',
    createGroup: 'Create Group',
    groupName: 'Group name',
    selectGroupMembers: 'Select group members',
    groups: 'Groups',
    add: 'Add',
    remove: 'Remove',
    openSidebar: 'Open sidebar',
    closeSidebar: 'Close sidebar',
    expandSidebar: 'Expand sidebar',
    collapseSidebar: 'Collapse sidebar',
    messageDetails: 'Message Details',
    status: 'Status',
    dateSent: 'Date Sent',
    timeSent: 'Time Sent',
    daySent: 'Day',
    seenAt: 'Seen at',
    // Sidebar / tabs
    tabAll: 'All',
    tabChats: 'Chats',
    tabGroups: 'Groups',
    tabUnread: 'Unread',
    tabFavorites: 'Favorites',
    tabArchived: 'Archived',
    newChat: 'New Chat',
    moreOptions: 'More options',
    // Starred messages
    starredMessages: 'Starred Messages',
    noStarredMessages: 'No starred messages',
    starredHint: "Tap any message, then choose 'Star' to save it here",
    // Message actions
    reply: 'Reply',
    forwardAction: 'Forward',
    starAction: 'Star',
    unstarAction: 'Unstar',
    deleteAction: 'Delete',
    forwardTo: 'Forward to...',
    forwarded: 'Forwarded',
    replyingTo: 'Replying to',
    messageUnavailable: 'Message unavailable',
    you: 'You',
    // Chat header menu
    viewContact: 'View contact',
    mediaLinksDocs: 'Media, links and docs',
    pinChat: 'Pin chat',
    unpinChat: 'Unpin chat',
    addToFavorites: 'Add to favorites',
    removeFromFavorites: 'Remove from favorites',
    blockAction: 'Block',
    unblockAction: 'Unblock',
    blockedBanner: 'You blocked this contact. Unblock to send messages.',
    exitChat: 'Close chat',
    // Contact panel
    editName: 'Edit name',
    saveName: 'Save',
    commonGroups: 'Common groups',
    muteNotifications: 'Mute notifications',
    addToList: 'Add to list',
    listNamePrompt: 'List name',
    // Media/links/docs tabs
    mediaTab: 'Media',
    linksTab: 'Links',
    docsTab: 'Docs',
    noMediaFound: 'No media',
    noLinksFound: 'No links',
    noDocsFound: 'No documents',
    // In-chat search
    searchInChat: 'Search in chat',
    searchInChatPlaceholder: 'Search messages...',
    noMatches: 'No matches',
    nextMatch: 'Next',
    prevMatch: 'Previous',
    // Mini Chat Dock
    miniChatMinimize: 'Minimize',
    miniChatRestore: 'Restore',
    miniChatClose: 'Close chat',
    miniChatExpand: 'Expand dock',
    miniChatCollapse: 'Collapse dock',
    voiceCall: 'Voice call',
    videoCall: 'Video call',
    callComingSoon: 'Calling is not available yet.',
    newMessages: 'New Messages',
  },
  ar: {
    messages: 'الرسائل',
    searchPeople: 'ابحث عن أشخاص...',
    recentChats: 'المحادثات الأخيرة',
    allEmployees: 'جميع الموظفين',
    noResults: 'لا توجد نتائج',
    tryDifferent: 'جرب البحث بكلمة مختلفة',
    noEmployees: 'لا يوجد موظفون متاحون',
    selectPerson: 'اختر شخصًا لبدء المحادثة',
    yourMessages: 'رسائلك',
    activeNow: 'نشط الآن',
    offline: 'غير متصل',
    typing: 'يكتب...',
    sending: 'جاري الإرسال...',
    sent: 'تم الإرسال',
    delivered: 'تم التسليم',
    read: 'تم القراءة',
    seen: 'تم القراءة',
    justNow: 'الآن',
    startConversation: 'ابدأ محادثة',
    loading: 'جاري تحميل الرسائل...',
    errorTitle: 'خطأ',
    retry: 'إعادة المحاولة',
    typeMessage: 'اكتب رسالة...',
    cannotMessageSelf: 'لا يمكنك إرسال رسالة لنفسك',
    userInfoMissing: 'معلومات المستخدم غير متوفرة',
    sendFailed: 'فشل إرسال الرسالة. يرجى المحاولة مرة أخرى.',
    uploading: 'جاري الرفع...',
    file: 'ملف',
    download: 'تحميل',
    recording: 'جاري التسجيل...',
    voiceMessage: 'رسالة صوتية',
    stop: 'إيقاف',
    send: 'إرسال',
    cancel: 'إلغاء',
    microphoneAccess: 'يرجى السماح بالوصول للمايكروفون',
    sharedMedia: 'الوسائط المشتركة',
    aboutChat: 'حول هذه المحادثة',
    contactInfo: 'معلومات الاتصال',
    noSharedMedia: 'لا توجد وسائط مشتركة بعد.',
    createGroup: 'إنشاء مجموعة',
    groupName: 'اسم المجموعة',
    selectGroupMembers: 'اختر أعضاء المجموعة',
    groups: 'المجموعات',
    add: 'إضافة',
    remove: 'إزالة',
    openSidebar: 'فتح القائمة',
    closeSidebar: 'إغلاق القائمة',
    expandSidebar: 'توسيع القائمة',
    collapseSidebar: 'طي القائمة',
    messageDetails: 'تفاصيل الرسالة',
    status: 'الحالة',
    dateSent: 'تاريخ الإرسال',
    timeSent: 'وقت الإرسال',
    daySent: 'اليوم',
    seenAt: 'تم القراءة في',
    // الشريط الجانبي / التبويبات
    tabAll: 'الكل',
    tabChats: 'الدردشات',
    tabGroups: 'المجموعات',
    tabUnread: 'غير مقروءة',
    tabFavorites: 'المفضلة',
    tabArchived: 'المؤرشفة',
    newChat: 'محادثة جديدة',
    moreOptions: 'خيارات إضافية',
    // الرسائل المميزة
    starredMessages: 'الرسائل المميزة',
    noStarredMessages: 'لا توجد رسائل مميزة',
    starredHint: "اضغط علي أي رسالة ثم اختر 'تمييز بنجمة' لحفظها هنا",
    // إجراءات الرسالة
    reply: 'رد',
    forwardAction: 'إعادة توجيه',
    starAction: 'تمييز بنجمة',
    unstarAction: 'إزالة النجمة',
    deleteAction: 'مسح',
    forwardTo: 'إعادة توجيه إلى...',
    forwarded: 'تمت إعادة توجيهها',
    replyingTo: 'رد على',
    messageUnavailable: 'الرسالة غير متاحة',
    you: 'أنت',
    // قائمة رأس المحادثة
    viewContact: 'عرض جهة الاتصال',
    mediaLinksDocs: 'وسائط وروابط ومستندات',
    pinChat: 'تثبيت الدردشة',
    unpinChat: 'إلغاء التثبيت',
    addToFavorites: 'إضافة إلى المفضلة',
    removeFromFavorites: 'إزالة من المفضلة',
    blockAction: 'حظر',
    unblockAction: 'إلغاء الحظر',
    blockedBanner: 'لقد قمت بحظر جهة الاتصال هذه. قم بإلغاء الحظر لإرسال الرسائل.',
    exitChat: 'إغلاق المحادثة',
    // لوحة جهة الاتصال
    editName: 'تعديل الاسم',
    saveName: 'حفظ',
    commonGroups: 'المجموعات المشتركة',
    muteNotifications: 'كتم الإشعارات',
    addToList: 'إضافة إلى قائمة',
    listNamePrompt: 'اسم القائمة',
    // تبويبات الوسائط
    mediaTab: 'وسائط',
    linksTab: 'روابط',
    docsTab: 'مستندات',
    noMediaFound: 'لا توجد وسائط',
    noLinksFound: 'لا توجد روابط',
    noDocsFound: 'لا توجد مستندات',
    // البحث داخل المحادثة
    searchInChat: 'بحث داخل المحادثة',
    searchInChatPlaceholder: 'ابحث في الرسائل...',
    noMatches: 'لا توجد نتائج',
    nextMatch: 'التالي',
    prevMatch: 'السابق',
    // شريط المحادثات المصغّر
    miniChatMinimize: 'تصغير',
    miniChatRestore: 'استعادة',
    miniChatClose: 'إغلاق المحادثة',
    miniChatExpand: 'توسيع الشريط',
    miniChatCollapse: 'طي الشريط',
    voiceCall: 'مكالمة صوتية',
    videoCall: 'مكالمة فيديو',
    callComingSoon: 'خاصية الاتصال غير متاحة بعد.',
    newMessages: 'رسائل جديدة',
  },
};